import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import initApp from 'utils/functions/init';
import { Contexts } from 'constants/context';
// eslint-disable-next-line max-len
import PharmaciesProvidersContainer from 'modules/categories/pharmacies/container/PharmaciesProvidersContainer';
import { fetchDropdowns } from 'modules/categories/categoriesSlice';
import { useParams } from 'react-router-dom';
import { fetchSelectedealthPlan } from 'modules/healthPlans/healthPlansSlice';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const PharmaciesProvidersPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { healthPlanId } = useParams();

  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(Contexts.Pharmacies);
    dispatch(fetchDropdowns());
    dispatch(fetchSelectedealthPlan(healthPlanId));
  }, [dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <PharmaciesProvidersContainer />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

PharmaciesProvidersPage.propTypes = {};

PharmaciesProvidersPage.defaultProps = {};

export default PharmaciesProvidersPage;
